<div class="modal-header">
  <button type="button" class="close" (click)="close();">
    <span aria-hidden="true">&times;</span>
  </button>
  <h4 class="modal-title">CONFIRMATION</h4>
</div>
<div class="modal-body clearfix">
  <!-- <h3 class="hdrLine">JOIN A LEAGUE</h3> -->
  <div class="clearfix"></div>
  <div class="col-sm-12 pad0 text-justify">
    <span class="bold">Note:</span>

    This is a user created private contest. Prizes will be awarded to the winners only if six or more users join the contest.
    If there are less than six total users in the contest, the contest will be cancelled and coins will be refunded.
  </div>
</div>
<div class="modal-footer">
  <a (click)="ok()" class="btn sg-btn btn-3 btnPadding confirmBtn">I Agree</a>
  <a (click)="close()" class="btn sg-btn btn-3 btnPadding confirmBtn">Cancel</a>
</div>